<div class="item-selector-container" (click)="toggleList($event)"  (clickOutside)="handleClickOutside($event)" [ngClass]="{'hide-header': !showHeader}">
  @if (showHeader) {
    <div (click)="toggleList($event); stopProp($event)" class="current-item">
      {{ currentItem.name }}
    </div>
  }
  <div [ngClass]="{ opened: isOpened }" (click)="openList()" class="shadow items-container">
    <div class="row">
      @if (showHeader) {
        <div (click)="toggleList($event)" class="current-item">
          {{ currentItem.name }}
        </div>
      }
    </div>
    <div id="ListArea">
      <div class="list-area search row">
        <input
          (click)="stopProp($event)"
          [(ngModel)]="filterString"
          (ngModelChange)="filterStringChange.emit($event)"
          placeholder="Type to Filter"
          type="text"
          />
      </div>
      <div class="headerItemList row">
        @for (item of items | tableSearch: filterString | sortby: 'name'; track item) {
          <div
            (click)="itemSelected(item)"
            class="selectNetwork row"
            [ngClass]="{'item-selected': item.selected}"
            [matTooltip]="apiService.isNetworkClusterReadOnly(item) ? 'Network is Read Only' : ''"
            matTooltipPosition="right"
            matTooltipShowDelay="300"
            >
            @if (item.iconClass) {
              <div class="{{item.iconClass}}"></div>
            }
            @if (!item.iconClass) {
              <div class="status s{{ item.status || '' }}" id="nStatList{{ item.id }}" [ngClass]="{'read-only': apiService.isNetworkClusterReadOnly(item)}">
                <div class="anim5"></div>
                @if (item.haEnabled) {
                  <div class="ha-badge"></div>
                }
                @if (item.fipsEnabled) {
                  <div class="fips-badge">FIPS</div>
                }
              </div>
            }
            {{ item.name || item.label }}
          </div>
        }
        @if (showAddNewItem) {
          <div
            (click)="addNetItemSelected($event)"
            class="item row addItemButton"
            >
            <div class="icon append icon-BigSoftPlus"></div>
            <div class="content">{{addNewItemLabel}}</div>
          </div>
        }
      </div>
      @if (showManageItems) {
        <div class="navItem" id="ManageNetworkButton" routerLink="{{manageItemsLink}}" (click)="manageItemsSelected($event)">{{manageItemsLabel}}</div>
      }
    </div>
  </div>
</div>
